export function getPhraseSearchUiState(
  draft: string,
  applied: string,
  isProducts = false
) {
  const appliedPhrase = String(applied || "").trim();
  const draftPhrase = String(draft || "").trim();
  const hasApplied = appliedPhrase.length > 0;
  const draftRaw = String(draft || "");

  return {
    hasApplied,
    showApplyButton: !hasApplied,
    applyDisabled: !draftPhrase,
    /** Clear X in the bar while typing, or when a phrase chip is applied. */
    showClearButton: hasApplied || draftRaw.length > 0,
    inputValue: hasApplied ? "" : draftRaw,
    inputReadOnly: hasApplied,
    placeholder: hasApplied
      ? ""
      : isProducts
        ? 'e.g. "Jeans" or "Sunglasses"'
        : 'e.g. "summer" or "GRWM"',
    chipLabel: hasApplied ? `"${appliedPhrase}"` : "",
  };
}

/**
 * Same `single` value link-in-bio sends to query_based_cont / query_based_shop:
 * one ILIKE of the full phrase (`%%girls sparkle%%`), not one pattern per word.
 */
export function buildPhraseIlikePatterns(fullQuery: string): string[] {
  const query = String(fullQuery || "").trim();
  return query ? [`%%${query}%%`] : [];
}

export function applyPhraseDraft(draft: string): string | null {
  const next = String(draft || "").trim();
  return next || null;
}

/** Products word/phrase: require a title that is not the search word. */
export function canPublishKeywordCarousel(
  name?: string | null,
  query?: string | null
) {
  const title = String(name || "").trim();
  const phrase = String(query || "").trim();
  if (!title || !phrase) return false;
  return title.toLowerCase() !== phrase.toLowerCase();
}

export function getKeywordHelperText(isProducts = false) {
  return `We look for your word or phrase in ${
    isProducts
      ? "product names and descriptions"
      : "captions, titles, descriptions, and hashtags"
  } across your synced ${isProducts ? "products" : "content"}.`;
}

export const KEYWORD_MATCHING_LEARN_HREF = "https://browsable.ai/privacy";
export const KEYWORD_MATCHING_LEARN_LABEL = "Learn how matching works";
